import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { HttpEventType } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { SCVService } from '../../service/scv.service';
import { ToastService } from '../../service/toast.sevice';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ConsentComponent } from './consent/consent.component';
import { debug } from 'util';

@Component({
  selector: 'app-newupload',
  templateUrl: './newupload.component.html',
  styleUrls: ['./newupload.component.css']
})
export class NewuploadComponent implements OnInit {

  files: any[] = [];
  selectedCity: any;
  progress: number;
  block: boolean;
  uploadedFiles: File[] = [];
  consent: boolean = false;
  disableUploadBtn: boolean = true;
  disableClearBtn: boolean = true;
  isCustomerConsentAvilable: boolean = false;
  numberOfFiles: number;
  maxFileSize: number;
  fileExtention: string;
  count: number;
  isDataLoaded: boolean = false;


  constructor(
    public translate: TranslateService,
    private toast: ToastService,
    private route: Router,
    private scvService: SCVService,
    private consentPopup: MatDialog) {
    //this.translate.setDefaultLang('fr');

  }

  ngOnInit() {
    this.loadConfiguration();
    this.isCustomerConsentAvilable = this.scvService.getCustomerConsent();

    if (!this.isCustomerConsentAvilable) {
       this.consent = true;
    }

  }

  addFiles(e: any) {
    _.forEach(e.target.files, (file) => {
      if (!this.validateFile(file)) return;
      this.files.push(file);
      this.enableButton();
    });
  }

  triggerUpload(uploadAll: boolean, file: File) {
    if (this.files.length == 0) {
      let errorValue: string;
      this.translate.get('LABEL.UPLOAD.ERRORS.MIN_FILE_REQUIREMENT').subscribe((value) => {
        errorValue = value;
      });
      this.toast.Error(errorValue);
    }
    else
      this.validateAndUpload(this.files.length, this.files);

  }
  removeFile(file: File) {
    _.remove(this.files, (f) => {
      return f === file;
    });
    this.disableButton();
  }

  formatSubtitle = (percent: number): string => {
    let status: string;
    if (percent >= 100) {
      this.translate.get('LABEL.UPLOAD.WAIT').subscribe((resp) => {
        status = resp;
      });
    } else if (percent > 0) {
      this.translate.get('LABEL.UPLOAD.UPLOADING').subscribe((resp) => {
        status = resp;
      });

    } else {
      this.translate.get('LABEL.UPLOAD.NOT_STARTED').subscribe((resp) => {
        status = resp;
      });

    }
    return status;
  }

  validateAndUpload = (numberOfFiles: number, files: File[]) => {
    this.count = this.count + numberOfFiles;
    if (this.count <= this.numberOfFiles)
      this.uploadFile(files);
    else {
      this.toast.Error(this.getSummary("LABEL.UPLOAD.ERRORS.FOLDER_LIMIT_EXCEED"));
      this.count = this.count - numberOfFiles;
    }
  }

  uploadFile(files: File[]) {
    if (!this.scvService.IsAuthenticated()) {
      this.route.navigateByUrl('error/498')
    } else {
      this.block = true;
      let filesSize = 0;
      let count = 0;

      let noOfFiles = files.length;
      _.sortBy(files, (f) => {
        return f.size;
      })

      _.forEach((files), (f) => filesSize = filesSize + f.size)
      _.forEach(files, (file) => {
        let s = this.scvService.uploadService(file).subscribe((event) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(((event.loaded / filesSize)) * 100);
            if (this.progress > 100) this.progress = 100;
          } else if (event.type === HttpEventType.Response) {
            console.log(count++);
            this.uploadedFiles = this.uploadedFiles.concat(file);
            _.remove(files, (f) => {
              return f === file;
            });
            this.disableButton();
          }
        },
          (error) => {
            let errorValue: string;
            if (error.status == 0) {
              this.translate.get('LABEL.UPLOAD.ERRORS.SERVICE_UNAVILABLE').subscribe((value) => {
                errorValue = value;
              });
              this.toast.Error(errorValue);
              this.block = false;
              s.unsubscribe();
            } else if ("Invalid Extension" === error.error.status) {
              count++;
              this.toast.Error(this.getSummary("LABEL.UPLOAD.ERRORS.NOT_VALID_EXTENSION"));
              if (count == noOfFiles) this.disableProgress();
              this.disableUploadBtn = true;

            } else if ("Limit Exceed" === error.error.status) {
              count++;
              this.toast.Error(this.getSummary("LABEL.UPLOAD.ERRORS.FOLDER_LIMIT_EXCEED"));
              if (count == noOfFiles) this.disableProgress();
              this.disableUploadBtn = true;
            } else if ("Invalid file size" === error.error.status) {
              count++;
              this.toast.Error(this.getSummary("LABEL.UPLOAD.ERRORS.INVALID_FILE_SIZE"));
              if (count == noOfFiles) this.disableProgress();
              this.disableUploadBtn = true;

            } else {
              count++;
              this.toast.Error(error.error.message);
              if (count == noOfFiles) this.disableProgress();
              this.disableUploadBtn = true;
            }
          },
          () => {
            if (count == noOfFiles) this.disableProgress();
          });
        if (s.closed) return false;
      })
    }
  }
  getSummary(key: string): string {
    let summary: string;
    this.translate.get(key).subscribe((value) => {
      summary = value;
    });
    return summary;
  }


  disableProgress() {
    this.block = false;
    this.progress = 0;
  }

  openDialog() {
    const dialogRef = this.consentPopup.open(ConsentComponent, {
      width: '400px',
      data: { consent: this.consent }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.consent = result.consent
    });
  }

  removeAllFiles() {
    this.files.length = 0;
    this.disableButton();
  }

  disableButton() {
    if (this.files.length == 0) {
      this.disableUploadBtn = true;
      this.disableClearBtn = true;
    }
  }

  enableButton() {
    if (this.files.length > 0) {
      this.disableUploadBtn = false;
      this.disableClearBtn = false;
    }
  }

  validateFile(file: File): boolean {
    console.log('file byte', file.size);
    if (file.size > this.maxFileSize) {
      this.toast.Error(this.getSummary("LABEL.UPLOAD.ERRORS.INVALID_FILE_SIZE"));
      return false;
    }
    return true;
  }

  async loadConfiguration() {
    await this.scvService.sizeOfUploadedFilesByCustomerAttachmentID().toPromise().then((resp) => {
      this.numberOfFiles = resp.numberOfFileUpload;
      this.count = resp.count;
      this.maxFileSize = resp.maxFileSize * 1048576;
      this.isDataLoaded = true;
    }, (error) => {
      this.toast.Error(this.getSummary("LABEL.UPLOAD.ERRORS.SERVICE_UNAVILABLE"));
    })
  }
}

